<template>
  <div :class="type">
    <div v-if="!newQuestion" class="search-bar">
      <div class="search-head">
        <div class="input-holder">
          <input
            v-model="search"
            type="text"
            name="search"
            class="search-input"
            autocomplete="off"
            placeholder="Q&A searching..."
            @keyup="searching"
          >
          <SearchBarIcon class="search-icon" />
          <CloseIcon
            v-if="search"
            class="close-icon"
            @click="resetSearching"
          />
        </div>
        <Filters
          v-if="type === 'in-video'"
          :filters="filters"
          :class-name="type"
          type="filter-icon"
          class="filter"
          applied-counter
          @change="filtrate"
        />
        <Filters
          v-if="type === 'in-video'"
          :filters="order"
          :class-name="type"
          type="sort-icon"
          class="sort"
          @change="filtrate"
        />
      </div>
      <Filters
        v-if="type !== 'in-video'"
        :filters="filters"
        :class-name="type"
        type="filter"
        class="filter-desktop"
        applied-counter
        @change="filtrate"
      />
      <Filters
        v-if="type !== 'in-video'"
        :filters="order"
        :class-name="type"
        type="sort"
        class="sort-desktop"
        @change="filtrate"
      />
      <Filters
        v-if="type === 'main'"
        :filters="filters"
        :class-name="type"
        type="filter-sort"
        class="filter-sort"
        applied-counter
        @change="filtrate"
      />
    </div>
    <div v-else-if="newQuestion" class="qa-header">
      <button class="back-button" @click="back">
        <BackArrows />
        <span>back</span>
      </button>
    </div>
  </div>
</template>

<script>
import SearchBarIcon from '../assets/svg/icon-search.svg?vue-component';
import { delayOnKeyup } from '../utils/helper';
import BackArrows from '../assets/svg/icon-back.svg?vue-component';
import CloseIcon from '../assets/svg/close-icon.svg?vue-component';
import Filters from '../components/Filters';

export default {
  components: {
    SearchBarIcon,
    BackArrows,
    CloseIcon,
    Filters,
  },
  props: {
    type: { type: [String], default: '' },
  },
  data() {
    return {
      search: '',
      showMobileFilters: false,
      courses: null,
      newQuestion: false,
      questionCount: 0,
      query: {
        page: 1,
        order: 'created',
        ...(this.type === 'in-video') && { searchIn: 'lesson' },
        ...(this.type === 'main') && { type: 'main', layout: this.$nuxt?.layoutName },
        ...this.$route.query,
      },
      orderBy: {
        created: { text: this.$nuxt?.layoutName === 'instructor' ? 'Date posted' : 'Posted on', selected: true },
        recent: { text: this.$nuxt?.layoutName === 'instructor' ? 'Date last answered' : 'Last answered' },
        answers: { text: this.$nuxt?.layoutName === 'instructor' ? 'Number of answers' : 'Answers' },
        popularity: { text: this.$nuxt?.layoutName === 'instructor' ? 'Number of votes' : 'Popularity' },
      },
    };
  },
  async fetch() {
    if (this.type !== 'in-video') {
      this.courses = await this.$store.dispatch('courses/fetchPublic', this.$nuxt?.layoutName);
    }
  },
  computed: {
    filterByTypes() {
      if (['admin', 'instructor'].includes(this.$nuxt?.layoutName)) {
        return {
          unanswered: { text: 'Unanswered' },
          answered: { text: 'Answered' },
          unresolved: { text: 'Unresolved' },
          resolved: { text: 'Resolved' },
        };
      }

      return {
        answered: { text: 'Answered' },
        resolved: { text: 'Resolved' },
        ...(this.$store.state.auth.user ? { mine: { text: 'Mine' }, followed: { text: 'Followed' } } : {}),
        ...(this.$store.getters['auth/user'].role === 'admin' || (this.$store.getters['auth/perms'] && (this.$store.getters['auth/perms'].includes('admin-legacy.qa') || this.$store.getters['auth/perms'].includes('lms.qa-support'))) ? { unresolved: { text: 'Unresolved' }, unanswered: { text: 'Unanswered' } } : {}),
        ...(this.$store.getters['auth/perms'] && (this.$store.getters['auth/perms'].includes('admin-legacy.qa') || this.$store.getters['auth/perms'].includes('lms.qa-support'))) ? { mineanswered: { text: 'Mine Answered' } } : {},
      };
    },
    filters() {
      const filterBy = this.filterByTypes;
      // if (this.$store.getters['auth/user'].role !== 'admin' && (this.$store.getters['auth/perms'] && !this.$store.getters['auth/perms'].includes('lms.qa-support') && !this.$store.getters['auth/perms'].includes('admin.qa'))) {
      //   filterBy = { all: { text: 'Select all', first: true, all: true }, ...filterBy };
      // }

      if (this.$store.state.layout === 'mobile') {
        if (this.type === 'in-video') {
          const searchIn = {
            lesson: { text: 'Lesson', selected: true },
            course: { text: 'Course' },
          };

          return {
            searchIn: {
              name: 'Search in',
              values: searchIn,
            },
            filterBy: {
              name: 'Filter questions by',
              type: 'multiple',
              values: filterBy,
            },
            order: {
              name: 'Order by',
              values: this.orderBy,
            },
          };
        }

        let courses;
        if (this.courses) {
          courses = this.courses.reduce((p, c, i) => ({ ...p, [c.id]: { text: c.name, i } }), {});
          // courses = { all: { text: 'Select all', first: true, all: true }, ...courses };
        }

        return {
          courses: {
            name: this.$nuxt?.layoutName === 'instructor' ? 'By course' : 'Filter courses',
            type: 'multiple',
            values: courses,
          },
          filterBy: {
            name: this.$nuxt?.layoutName === 'instructor' ? 'By status' : 'Filter questions by',
            type: 'multiple',
            values: filterBy,
          },
          order: {
            name: 'Order by',
            values: this.orderBy,
          },
        };
      }

      if (this.type === 'in-video') {
        const searchIn = {
          lesson: { text: 'Lesson', selected: true },
          course: { text: 'Course' },
        };

        return {
          searchIn: {
            name: 'Search in',
            values: searchIn,
          },
          filterBy: {
            name: 'Filter questions by',
            type: 'multiple',
            values: filterBy,
          },
        };
      }

      let courses;
      if (this.courses) {
        courses = this.courses.reduce((p, c, i) => ({ ...p, [c.id]: { text: c.name, i } }), {});
        // courses = { all: { text: 'Select all', first: true, all: true }, ...courses };
      }
      return {
        courses: {
          name: this.$nuxt?.layoutName === 'instructor' ? 'By course' : 'Filter courses',
          type: 'multiple',
          values: courses,
        },
        filterBy: {
          name: this.$nuxt?.layoutName === 'instructor' ? 'By status' : 'Filter questions by',
          type: 'multiple',
          values: filterBy,
        },
      };
    },
    order() {
      return {
        order: {
          name: 'Order by',
          values: this.orderBy,
        },
      };
    },
  },
  async mounted() {
    if (this.$route.query.search) {
      this.search = this.$route.query.search;
    }
    this.$root.$off('counting');
    this.$root.$on('counting', (count) => {
      this.questionCount = count;
    });
  },
  created() {
    this.$root.$on('new-question', this.handleNewQuestion);
    this.$root.$on('back-to-questions', this.handleBacktoQuestion);
  },
  beforeDestroy() {
    this.$root.$off('new-question', this.handleNewQuestion);
    this.$root.$off('back-to-questions', this.handleBacktoQuestion);
  },
  methods: {
    filtrate(f) {
      let params;
      if (f.search) {
        if (!f.search.length) {
          delete this.query.search;
        } else {
          params = f;
        }
      } else {
        params = Object.entries(f.filter).reduce((p, [q, v]) => ({ ...p, ...(v.length ? { [q]: v.join(',').replace(',all', '') } : delete this.query[q]) }), {});
      }
      this.query = { ...this.query, ...params, page: 1 };
      const queryParams = Object.entries(this.query).map(([q, v]) => `${q}=${v}`).join('&');
      if (this.type === 'main') {
        let url = `${this.$config.appUrl || this.$config.siteUrl}/qa-hub/?${queryParams}`;
        if (['admin', 'instructor'].includes(this.$nuxt?.layoutName)) {
          url = `${this.$config.appUrl || this.$config.siteUrl}/${this.$nuxt?.layoutName}/qa-hub/?${queryParams}`;
        }
        // eslint-disable-next-line no-restricted-globals
        history.pushState({}, null, url);
      }
      this.$root.$emit('filtrate', queryParams);
    },
    removeQuery(filter) {
      const query = { ...this.query };
      delete query[filter];
      query.page = 1;
      this.filtrate(query);
    },
    searching() {
      delayOnKeyup(() => {
        this.filtrate({ search: this.search || {} });
      });
    },
    ask() {
      if (this.$config.project === 'site') {
        this.$router.push('/signup/');
      } else {
        this.$root.$emit('new-question');
        this.newQuestion = true;
      }
    },
    back() {
      this.$root.$emit('back-to-questions');
      this.newQuestion = false;
    },
    resetSearching() {
      this.search = '';
      this.searching();
    },
    handleNewQuestion() {
      this.newQuestion = true;
    },
    handleBacktoQuestion() {
      this.newQuestion = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.search-bar {
  position: relative;
  margin: 0 auto var(--spacing-sm);
  width: 55%;

  .search-head {
    display: flex;
    justify-content: space-between;

    .input-holder {
      position: relative;
      display: block !important;
      height: 100%;
      width: 100%;

      .search-input {
        height: 40px;
        padding-left: 40px;
        padding-right: 40px;
        color: var(--main-dark-shade-0);
        border: 1px solid var(--main-light-shade-3);
        border-radius: 100px;
      }

      .search-icon {
        position: absolute;
        left: 0;
        margin: 0 12px;
        top: 50% !important;
        margin-top: -10px;
      }

      .close-icon {
        position: absolute;
        right: 15px;
        top: 50% !important;
        margin-top: -7px;

        path {
          fill: var(--main-light-shade-4);
        }
      }
    }

    .btn-primary {
      margin: 0 0 0 36px;
    }
  }

  ::v-deep {
    .__filters-dropdown .__filters-arrow-up {
      svg {
        path[stroke] {
          stroke: var(--main-light-shade-4);
        }
      }
    }
  }
}

button {
  cursor: pointer;
  color: var(--main-light-shade-1);
  margin-bottom: 16px;

  &.btn-primary {
    min-width: 166px;
    max-width: 180px;
    font-size: 16px;
    border-radius: 3px;
  }
}

.back-button {
  margin-top: var(--spacing-sm);
  border-radius: 3px;
  cursor: pointer;
  border: 0;
  background: var(--lighter-gray);
  padding: 4px;
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  position: relative;
  text-decoration: unset;

  span {
    color: var(--gray);
    opacity: 0.8;
  }
}

.in-video {
  .qa-header {
    padding: 0 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .back-button {
      margin-top: var(--spacing-sm);
    }
  }

  .search-bar {
    display: flex;
    flex-wrap: wrap;

    .search-head {
      width: 100%;
      margin-bottom: var(--spacing-12);
    }

    .sort-desktop {
      margin-left: var(--spacing-8);
    }
  }
}

.main {
  .search-bar {
    margin: 0 auto var(--spacing-sm);
    width: 100%;
    display: flex;
    align-items: center;

    .search-head {
      width: 100%;
    }

    .filter-desktop {
      margin: 0 var(--spacing-8);
    }
  }
}

.filter-sort {
  display: none;
}

@include bp($bp-mobile) {
  .filter-sort {
    display: flex;
    margin-left: var(--spacing-6);
  }

  .filter-desktop,
  .sort-desktop {
    display: none;
  }

  .in-video {
    .search-bar {
      margin: 0 auto var(--spacing-8);
      flex-direction: column;
      width: 100%;

      .search-head {
        align-items: center;

        .input-holder {
          svg {
            top: 16px;
          }

          .btn-primary {
            margin-top: var(--spacing-8);
            width: 100%;
            max-width: 328px;
          }
        }

        .filter-sort {
          margin-top: 0;
          padding-right: 0;
          padding-left: var(--spacing-6);
        }
      }

      .btn-primary {
        margin: var(--spacing-8) 0 0 0;
        max-width: 100%;
        width: 100%;
      }
    }

    .qa-header {
      padding: 0;
    }
  }

  .search-bar .search-head .input-holder .search-input {
    height: 48px;
  }

  .main .search-bar,
  .in-video .search-bar {
    display: flex;
    align-items: center;
    margin-bottom: var(--spacing-8);

    .input-holder {
      width: 100%;
    }

    svg {
      margin-left: var(--spacing-6);
      cursor: pointer;
      flex: 0 0 auto;
    }

    .background {
      visibility: hidden;
      opacity: 0;
      transition: all var(--duration) ease;
      position: fixed;
      display: block;
      top: 68px;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 12, 31, 0.8);
      z-index: 1;

      &.show {
        visibility: visible;
        opacity: 1;
      }
    }
  }

  .qa-header {
    margin-bottom: var(--spacing-28);

    button {
      width: 100%;
      max-width: 328px;
      height: 52px;
      padding: 0;
      margin: 0;
      border-radius: 4px;
    }
  }
}

.fa {
  .main .search-bar .filter-desktop {
    margin-right: var(--spacing-12);
  }
}
</style>
